import { Auth } from "aws-amplify";
import React, { useState } from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { checkRole } from "../../utils/role";
import ContainerContent from "../Container/ContainerContent";
import InterestTable from "./footage/leasing.f.interestTable";
import LoadingPage from "../Loading/LoadingPage";
import Skeleton from "react-loading-skeleton";
import InterestTFTable from "./footage/leasing.f.interestTFTable";
import { Dialog } from "@headlessui/react";
import Swal from "sweetalert2";
import classNames from "classnames";
import API from "./api/api.main";

const Interest = ({ type, label }) => {
  const [interests, setInterests] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchInterest();
  }, []);

  const fetchInterest = async () => {
    try {
      setLoading(true);
      if (type === "interest_ntf") {
        const interestCar = await API.get(
          "MoneyHubAdmin",
          `/leasing/interest`,
          {
            queryStringParameters: {
              name: "INTEREST_CAR",
            },
          }
        );
        const interestMotobike = await API.get(
          "MoneyHubAdmin",
          `/leasing/interest`,
          {
            queryStringParameters: {
              name: "INTEREST_MOTORBIKE",
            },
          }
        );
        const interestNtfPenaltyCar = await API.get(
          "MoneyHubAdmin",
          `/leasing/interest`,
          {
            queryStringParameters: {
              name: "INTEREST_NTF_PENALTY_CAR",
            },
          }
        );
        const interestNtfPenaltyMotobike = await API.get(
          "MoneyHubAdmin",
          `/leasing/interest`,
          {
            queryStringParameters: {
              name: "INTEREST_NTF_PENALTY_MOTORBIKE",
            },
          }
        );
        setInterests([
          {
            name: "รถยนต์",
            value: interestCar.INTEREST_CAR,
            keyName: "INTEREST_CAR",
            type,
          },
          {
            name: "จักรยานยนต์",
            value: interestMotobike.INTEREST_MOTORBIKE,
            keyName: "INTEREST_MOTORBIKE",
            type,
          },
          {
            name: "ดอกเบี้ยผิดนัด (รถยนต์)",
            value: interestNtfPenaltyCar.INTEREST_NTF_PENALTY_CAR,
            keyName: "INTEREST_NTF_PENALTY_CAR",
            type,
          },
          {
            name: "ดอกเบี้ยผิดนัด (จักรยานยนต์)",
            value: interestNtfPenaltyMotobike.INTEREST_NTF_PENALTY_MOTORBIKE,
            keyName: "INTEREST_NTF_PENALTY_MOTORBIKE",
            type,
          },
        ]);
      } else if (type === "interest_tf") {
        const interestPenaltyTF = await API.get(
          "MoneyHubAdmin",
          `/leasing/interest`,
          {
            queryStringParameters: {
              name: "INTEREST_PENALTY_TF",
            },
          }
        );
        setInterests([
          {
            name: "ดอกเบี้ยผิดนัด",
            value: interestPenaltyTF?.INTEREST_PENALTY_TF,
            keyName: "INTEREST_PENALTY_TF",
            type,
          },
        ]);
      } else if (type === "duration") {
        const interestDatePenalty = await API.get(
          "MoneyHubAdmin",
          `/leasing/interest`,
          {
            queryStringParameters: {
              name: "INTEREST_PENALTY_DATE",
            },
          }
        );
        const interestCanAddDemandFee = await API.get(
          "MoneyHubAdmin",
          `/leasing/interest`,
          {
            queryStringParameters: {
              name: "CAN_ADD_DEMAND_FEE_DATE",
            },
          }
        );
        const interestReturnCarDate = await API.get(
          "MoneyHubAdmin",
          `/leasing/interest`,
          {
            queryStringParameters: {
              name: "RETURN_CAR_DATE",
            },
          }
        );
        setInterests([
          {
            name: "จำนวนวันค้างชำระ",
            value: interestDatePenalty.INTEREST_PENALTY_DATE,
            keyName: "INTEREST_PENALTY_DATE",
            type,
          },
          {
            name: "จำนวนวันที่ auto ค่าทวงถาม",
            value: interestCanAddDemandFee.CAN_ADD_DEMAND_FEE_DATE,
            keyName: "CAN_ADD_DEMAND_FEE_DATE",
            type,
          },
          {
            name: "จำนวนวันที่ค่ายกเลิกสัญญา",
            value: interestReturnCarDate.RETURN_CAR_DATE,
            keyName: "RETURN_CAR_DATE",
            type,
          },
        ]);
      } else if (type === "fee") {
        const feeVisitFee = await API.get(
          "MoneyHubAdmin",
          `/leasing/interest`,
          {
            queryStringParameters: {
              name: "VISIT_FEE",
            },
          }
        );
        const feeฺBreakFee = await API.get(
          "MoneyHubAdmin",
          `/leasing/interest`,
          {
            queryStringParameters: {
              name: "BREAK_FEE",
            },
          }
        );
        const feeDemandFee = await API.get(
          "MoneyHubAdmin",
          `/leasing/interest`,
          {
            queryStringParameters: {
              name: "DEMAND_FEE_NTF_ONE",
            },
          }
        );
        const feeDemandFeeTwo = await API.get(
          "MoneyHubAdmin",
          `/leasing/interest`,
          {
            queryStringParameters: {
              name: "DEMAND_FEE_NTF_TWO",
            },
          }
        );
        const returnCar = await API.get("MoneyHubAdmin", `/leasing/interest`, {
          queryStringParameters: {
            name: "RETURN_CAR",
          },
        });
        const stamp = await API.get("MoneyHubAdmin", `/leasing/interest`, {
          queryStringParameters: {
            name: "STAMP",
          },
        });
        const estimateCar = await API.get(
          "MoneyHubAdmin",
          `/leasing/interest`,
          {
            queryStringParameters: {
              name: "ESTIMATE_CAR",
            },
          }
        );
        const feeMotobikeCar = await API.get(
          "MoneyHubAdmin",
          `/leasing/interest`,
          {
            queryStringParameters: {
              name: "FEE_MOTORBIKE",
            },
          }
        );
        const feeTransfer = await API.get(
          "MoneyHubAdmin",
          `/leasing/interest`,
          {
            queryStringParameters: {
              name: "FEE_TRANSFER",
            },
          }
        );
        const feeInspection = await API.get(
          "MoneyHubAdmin",
          `/leasing/interest`,
          {
            queryStringParameters: {
              name: "FEE_INSPECTION",
            },
          }
        );
        const feeService = await API.get(
          "MoneyHubAdmin",
          `/leasing/interest`,
          {
            queryStringParameters: {
              name: "FEE_SERVICE",
            },
          }
        );
        setInterests([
          {
            name: "ค่าทวงถาม (ครั้งแรก)",
            value: feeDemandFee.DEMAND_FEE_NTF_ONE,
            keyName: "DEMAND_FEE_NTF_ONE",
          },
          {
            name: "ค่าทวงถาม (ครั้งสองขึ้นไป)",
            value: feeDemandFeeTwo.DEMAND_FEE_NTF_TWO,
            keyName: "DEMAND_FEE_NTF_TWO",
          },
          {
            name: "ค่าลงพื้นที่",
            value: feeVisitFee.VISIT_FEE,
            keyName: "VISIT_FEE",
            type,
          },
          {
            name: "ค่ายกเลิกสัญญา",
            value: feeฺBreakFee.BREAK_FEE,
            keyName: "BREAK_FEE",
            type,
          },
          {
            name: "ค่าเสียผลประโยชน์",
            value: returnCar.RETURN_CAR,
            keyName: "RETURN_CAR",
            type,
          },
          {
            name: "ค่าอากรแสตมป์",
            value: stamp.STAMP,
            keyName: "STAMP",
            type,
          },
          {
            name: "ค่าประเมินรถยนต์ (CAR)",
            value: estimateCar.ESTIMATE_CAR,
            keyName: "ESTIMATE_CAR",
            type,
          },
          {
            name: "ค่าธรรรมเนียมการใช้วงเงิน (MOTORBIKE)",
            value: feeMotobikeCar.FEE_MOTORBIKE,
            keyName: "FEE_MOTORBIKE",
            type,
          },
          {
            name: "ค่าโอนทะเบียนกรรมสิทธิ์",
            value: feeTransfer.FEE_TRANSFER,
            keyName: "FEE_TRANSFER",
            type,
          },
          {
            name: "ค่าตรวจสภาพรถ",
            value: feeInspection.FEE_INSPECTION,
            keyName: "FEE_INSPECTION",
            type,
          },
          {
            name: "ค่าบริการ",
            value: feeService?.FEE_SERVICE,
            keyName: "FEE_SERVICE",
            type,
          },
        ]);
      }
    } catch (error) {
      console.log("fetch interest error", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="my-8">
        <h2 className="mx-4 font-semibold">{label}</h2>
        {loading ? (
          <div className="mx-4">
            <Skeleton height={28} count={10} />
          </div>
        ) : (
          <InterestTable
            data={interests}
            getData={fetchInterest}
            where={{}}
            type={type}
          />
        )}
      </div>
    </div>
  );
};

const InterestTF = () => {
  const [interests, setInterests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openAddModal, setOpenAddModal] = useState(false);
  const [loadingAdd, setLoadingAdd] = useState(false);
  const [formAdd, setFormAdd] = useState({});
  const [error, setError] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await API.get("MoneyHubAdmin", `/leasing/interestSetting`, {
        queryStringParameters: {
          setting: "INTEREST_TF",
        },
      });
      setInterests(res?.interests);
    } catch (error) {
      console.log("fetch interest error", error);
    } finally {
      setLoading(false);
    }
  };

  const onClickAdd = async () => {
    try {
      setLoadingAdd(true);
      const result = await Swal.fire({
        title: "คุณยืนยันที่จะอนุมัตินี้หรือไม่ ?",
        showCancelButton: true,
        confirmButtonText: `บันทึก`,
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
        showLoaderOnDeny: false,
        preConfirm: async () => {
          if (
            !formAdd?.year ||
            !formAdd.period_12 ||
            !formAdd.period_24 ||
            !formAdd.period_36 ||
            !formAdd.period_48 ||
            !formAdd.period_60 ||
            !formAdd.period_12_eff ||
            !formAdd.period_24_eff ||
            !formAdd.period_36_eff ||
            !formAdd.period_48_eff ||
            !formAdd.period_60_eff
          ) {
            setError(true);
            return {
              error: true,
            };
          }

          if (
            Number(formAdd?.period_12_eff) < 8 ||
            Number(formAdd?.period_24_eff) < 11.6 ||
            Number(formAdd?.period_36_eff) < 12.8 ||
            Number(formAdd?.period_48_eff) < 13.2 ||
            Number(formAdd?.period_60_eff) < 13.6
          ) {
            setError(true);
            return {
              error: false,
              error2: true,
            };
          }

          await API.post("MoneyHubAdmin", `/leasing/interestTF`, {
            body: {
              year: formAdd?.year,
              ...formAdd,
            },
            headers: {
              Authorization: `Bearer ${(await Auth.currentSession())
                .getIdToken()
                .getJwtToken()}`,
            },
          });
        },
      });
      if (result.value?.error) {
        return await Swal.fire({
          title: "WARNING",
          text: `โปรดกรอกข้อมูลอัพตราดอกเบี้ย`,
          icon: "warning",
          confirmButtonText: "ยืนยัน",
        });
      }
      if (result.value?.error2) {
        return await Swal.fire({
          title: "WARNING",
          text: `โปรดกรอกข้อมูลอัตราดอกเบี้ยให้ถูกต้อง`,
          icon: "warning",
          confirmButtonText: "ยืนยัน",
        });
      }
      if (!result.isConfirmed) return;
      await Swal.fire({
        title: "SUCCESS",
        text: "อัพเดตข้อมูลสำเร็จ",
        icon: "success",
        confirmButtonText: "ยืนยัน",
      });
      await fetchData();
      setFormAdd({});
      setOpenAddModal(false);
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoadingAdd(false);
    }
  };

  return (
    <div>
      <div className="my-8">
        <h2 className="mx-4 font-semibold">อัตราดอกเบี้ย (เช่าซื้อ)</h2>
        {loading ? (
          <div className="mx-4">
            <Skeleton height={28} count={10} />
          </div>
        ) : (
          <InterestTFTable data={interests} getData={fetchData} where={{}} />
        )}
        <div className="px-4">
          <button
            onClick={() => setOpenAddModal(true)}
            className="flex items-center justify-center px-2 py-2 bg-blue-500 text-white w-full rounded"
          >
            เพิ่มข้อมูล
          </button>
          <Dialog
            open={openAddModal}
            className="fixed z-10 inset-0 overflow-y-auto"
            onClose={() => setOpenAddModal(false)}
          >
            <div className="flex items-center justify-center min-h-screen">
              <div className="bg-white border border-gray-300 rounded max-w-sm mx-auto p-4 z-20">
                <Dialog.Title className="font-black text-lg">
                  เพิ่มข้อมูลดอกเบี้ย
                </Dialog.Title>
                <Dialog.Description className="my-4">
                  <div className="">
                    {[
                      { label: "ปีรถ", name: "year", type: "text" },
                      {
                        label: "งวด 12",
                        name: "period_12",
                        name2: "period_12_eff",
                        validate: 8,
                      },
                      {
                        label: "งวด 24",
                        name: "period_24",
                        name2: "period_24_eff",
                        validate: 11.6,
                      },
                      {
                        label: "งวด 36",
                        name: "period_36",
                        name2: "period_36_eff",
                        validate: 12.8,
                      },
                      {
                        label: "งวด 48",
                        name: "period_48",
                        name2: "period_48_eff",
                        validate: 13.2,
                      },
                      {
                        label: "งวด 60",
                        name: "period_60",
                        name2: "period_60_eff",
                        validate: 13.6,
                      },
                    ].map((item, index) => {
                      if (item.label === "ปีรถ") {
                        return (
                          <div key={index} className="mb-2">
                            {" "}
                            <div>{item?.label}</div>
                            <div className="ml-1 flex flex-col mb-1">
                              <div className="">{item.label}</div>
                              <div className="flex items-center space-x-1">
                                <input
                                  className="border border-gray-300 focus:outline-none px-3 py-2 rounded"
                                  type={item?.type ? item?.type : "number"}
                                  name={item.name}
                                  value={formAdd[item?.name]}
                                  onChange={(e) =>
                                    setFormAdd({
                                      ...formAdd,
                                      [item?.name]: e.target.value,
                                    })
                                  }
                                />
                                <span className="text-red-400 mx-2">
                                  {error && !formAdd?.year && "โปรดกรอกข้อมูล"}
                                </span>
                              </div>
                            </div>
                          </div>
                        );
                      }

                      return (
                        <div key={index} className="mb-2">
                          {" "}
                          <div>{item?.label}</div>
                          <div className="ml-1 flex flex-col mb-1">
                            <div className="">Flat Rate</div>
                            <div className="flex flex-col space-x-1">
                              <input
                                className="border border-gray-300 focus:outline-none px-3 py-2 rounded"
                                type={item?.type ? item?.type : "number"}
                                name={item.name}
                                value={formAdd[item?.name]}
                                onChange={(e) =>
                                  setFormAdd({
                                    ...formAdd,
                                    [item?.name]: e.target.value,
                                  })
                                }
                              />
                              <span className="text-red-400 mx-2">
                                {error &&
                                  !formAdd[item.name] &&
                                  "โปรดใส่ข้อมูล"}
                              </span>
                            </div>
                          </div>
                          <div className="ml-1 flex flex-col">
                            <div className="">
                              Effective Interest Rate (min = {item?.validate})
                            </div>
                            <div className="flex flex-col space-x-1">
                              <input
                                className="border border-gray-300 focus:outline-none px-3 py-2 rounded"
                                type={item?.type ? item?.type : "number"}
                                name={item.name2}
                                value={formAdd[item?.name2]}
                                onChange={(e) =>
                                  setFormAdd({
                                    ...formAdd,
                                    [item?.name2]: e.target.value,
                                  })
                                }
                              />
                              <span className="text-red-400 mx-2">
                                {!formAdd[item?.name2] && "โปรดกรอกข้อมูล"}
                              </span>
                              <span className="text-red-400 mx-2">
                                {formAdd[item?.name2] &&
                                  formAdd[item?.name2] < item?.validate &&
                                  `ขั้นต่ำ ${item?.validate}`}
                              </span>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </Dialog.Description>
                <button
                  disabled={loadingAdd}
                  className={classNames("p-2 text-white w-20 mr-4 rounded", {
                    "bg-gray-400 cursor-not-allowed": loadingAdd,
                    "bg-blue-500": !loadingAdd,
                  })}
                  onClick={onClickAdd}
                >
                  ตกลง
                </button>
                <button
                  className="p-2 text-blue-500 border border-blue-500 w-20 rounded"
                  onClick={() => setOpenAddModal(false)}
                >
                  ยกเลิก
                </button>
              </div>
            </div>
          </Dialog>
        </div>
      </div>
    </div>
  );
};

const Broken = ({ type, label }) => {
  const [interests, setInterests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openAddModal, setOpenAddModal] = useState(false);
  const [loadingAdd, setLoadingAdd] = useState(false);
  const [formAdd, setFormAdd] = useState({});
  const [error, setError] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await API.get("MoneyHubAdmin", `/leasing/interestSetting`, {
        queryStringParameters: {
          setting: "BROKEN",
        },
      });
      setInterests(res?.interests.filter((interest) => interest.type === type));
    } catch (error) {
      console.log("fetch interest error", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="my-8">
        <h2 className="mx-4 font-semibold">{label}</h2>
        {loading ? (
          <div className="mx-4">
            <Skeleton height={28} count={10} />
          </div>
        ) : (
          <InterestTable
            data={interests}
            getData={fetchData}
            where={{}}
            type={"broken"}
          />
        )}
      </div>
    </div>
  );
};

function LeasingSettingInterestMain() {
  const { user } = useSelector((state) => state.initializeApp);
  const [password, setPassword] = useState("");
  const checkPasswordMatch = "11004";

  if (password === checkPasswordMatch) {
    return (
      <ContainerContent>
        {checkRole(user.groups, ["SuperAdmin", "Marketing"]) && <InterestTF />}
        {checkRole(user.groups, ["SuperAdmin", "Marketing"]) && (
          <Interest
            label="ตารางอัตราดอกเบี้ยผิดนัด (เช่าซื้อ)"
            type="interest_tf"
          />
        )}
        {checkRole(user.groups, ["SuperAdmin", "Marketing"]) && (
          <Interest label="ตารางอัตราดอกเบี้ย (จำนำ)" type="interest_ntf" />
        )}
        {checkRole(user.groups, ["SuperAdmin", "Marketing"]) && (
          <Interest label="ตารางตั้งค่าจำนวนวัน" type="duration" />
        )}
        {checkRole(user.groups, ["SuperAdmin", "Marketing"]) && (
          <Interest label="ตารางค่าธรรมเนียม" type="fee" />
        )}
        {checkRole(user.groups, ["SuperAdmin", "Marketing"]) && (
          <Broken label="ค่าเสื่อมสภาพรถยนต์" type="CAR" />
        )}
        {checkRole(user.groups, ["SuperAdmin", "Marketing"]) && (
          <Broken label="ค่าเสื่อมสภาพรถจักรยานยนต์" type="MOTORBIKE" />
        )}
      </ContainerContent>
    );
  }

  return (
    <ContainerContent>
      <div className="flex items-center justify-center h-full">
        <div>Password</div>
        <input
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          type="password"
          className="ml-2 px-2 py-1 mr-auto bg-transparent  relative border-b border-blue-400 text-sm outline-none bg-gray-50 focus:outline-none focus:border-blue-700 focus:ring-0 ring-0"
        />
      </div>
    </ContainerContent>
  );
}

export default LeasingSettingInterestMain;
